import React from "react";
import { AppDrawer } from "../Components/AppDrawer";
import { setTitle } from "../Components/AppDrawer/store/AppDrawerSlicer";
import { useAppDispatch } from "../hooks";

import Dashboard from "./Dashboard";
import Audio from "./Audio";
import Video from "./Video";
import Climate from "./Climate";
import Conference from "./Conference";
import Curtains from "./Curtains";
import Lights from "./Lights";
import Notifications from "./Notifications";
import Security from "./Security";
import Analytics from "./Analytics";
import { Pages } from "../Utils/Types";

import { selectTitle } from "../Components/AppDrawer/store/AppDrawerSlicer";
import { useAppSelector } from "../hooks";

const MainPage = () => {
  const headerTitle = useAppSelector(selectTitle);
  const setChildren = () => {
    switch (headerTitle) {
      case Pages.Dashboard:
        return <Dashboard />;
      case Pages.Audio:
        return <Audio />;
      case Pages.Video:
        return <Video />;
      case Pages.Climate:
        return <Climate />;
      case Pages.Conference:
        return <Conference />;
      case Pages.Curtains:
        return <Curtains />;
      case Pages.Lights:
        return <Lights />;
      case Pages.Notifications:
        return <Notifications />;
      case Pages.Security:
        return <Security />;
      case Pages.Analytics:
        return <Analytics />;
    }
  };
  return (
    <AppDrawer>
      <>{setChildren()}</>
    </AppDrawer>
  );
};

export default MainPage;
